import { createFileRoute, redirect } from '@tanstack/react-router';
import { SETTINGS_SECTIONS, visibleSettingsSections } from '../components/shell/nav';
import { canDo, LOCAL_ME } from '../lib/session';

/** `/settings` opens the first section the person may open. */
export const Route = createFileRoute('/settings/')({
  beforeLoad: ({ search, context }) => {
    const me = context.me ?? LOCAL_ME;
    const first = visibleSettingsSections((need) => canDo(me, need))[0] ?? SETTINGS_SECTIONS[0];
    throw redirect({ to: first.path, search, replace: true });
  },
});
